const profileTypes = {
  MATRIMONIO: 1,
  MAMA: 2,
  ASESOR: 3
}
export {
  profileTypes
};
